import TourCard from './TourCard';

export default TourCard;
